// extracted by mini-css-extract-plugin
module.exports = {"message_box":"InternalMessageBox_message_box__khPMg","buttons":"InternalMessageBox_buttons__DfcP0"};